// ** React Imports
import { Link, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'

// ** Custom Components
import Avatar from '@components/avatar'

// ** Utils
import { isUserLoggedIn } from '@utils'

// ** Store & Actions
import { useDispatch, useSelector } from 'react-redux'
import { handleLogout } from '@store/authentication'

// ** Third Party Components
import { User, Mail, CheckSquare, MessageSquare, Settings, CreditCard, HelpCircle, Power } from 'react-feather'

// ** Reactstrap Imports
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap'

// ** Default Avatar Image
import defaultAvatar from '../../../../../src/assets/images/avatars/avatar-blank.png' // @src/assets/images/avatars/avatar-default.png'
import { getMyprofile } from '../../../../views/pages/Home/store'
import { baseUrl } from '../../../../app.config'
import axios from 'axios'
import { getNameFromUrl } from '../../../../utility/Utils'
import toast from 'react-hot-toast'

const UserDropdown = ({connected}) => {
  // ** Store Vars
  const dispatch = useDispatch()

  // ** State
  const [userData, setUserData] = useState(null)
  
  //** ComponentDidMount
  useEffect(() => {
    if (isUserLoggedIn() !== null) {
      setUserData(JSON.parse(localStorage.getItem('userData')))
    }
  }, [])

  //** Vars
  const userAvatar = (userData && userData.avatar) || defaultAvatar

  const logOut = ()=>{
    dispatch(handleLogout())   
    // try {
    //   const url = `${baseUrl}/userapi/logoutUser`
    //   const headers = {}
    //   axios.post(url, {}, { withCredentials:true ,headers })
    //   .then((res) => {        
    //     if (res.status === 200) {

    //       dispatch(handleLogout())        
    //     } else {
    //       console.log("🚀 ~ file: UserDropdown.js:64 ~ .then ~ res:", res)
    //     }
    //   })
    //   .catch((err) => {
    //   toast.error(err?.response?.data?.message)
    //   console.log("🚀 ~ file: Register.js:96 ~ handleRegisterSubmit ~ err:", err)
    //   })
  
    // } catch (error) {    
    //   console.log(error)
    // }
  }

  return (
    <UncontrolledDropdown tag='li' className='dropdown-user nav-item'>
      <DropdownToggle href='/' tag='a' className='nav-link dropdown-user-link' onClick={e => e.preventDefault()}>
        <div className='user-nav d-sm-flex d-none'>
          <span className='user-name fw-bold'>{userData?.Name}</span>
          <span className='user-status'>{userData?.Email}</span>
        </div>
        <Avatar img={userAvatar} imgHeight='40' imgWidth='40' status={connected===1 ? 'online' : 'offline'} />
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem tag={Link} to='/home/profile'>
          <User size={14} className='me-75' />
          <span className='align-middle'>Profile</span>
        </DropdownItem>
        <DropdownItem tag={Link} to='/' onClick={logOut}>
          <Power size={14} className='me-75' />
          <span className='align-middle'>Logout</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default UserDropdown
